'use es6';

import { getDelegatedBoundsElementsByNameOrPath } from 'layout-dnd-utils/dom/delegates';
import { buildCalculateNodePositions } from 'layout-dnd-utils/nodePositions/nodePositionCalculator';
import PerformanceStatsGatherer from 'ContentEditorUI/lib/PerformanceStatsGatherer';
import { setDelegatedElementsForConfigToUse, setViewportBoundsForConfigToUse } from 'InpageEditorUI/lib/layoutSection/nodePositionConfig';
import { getCurrentViewportBounds } from 'layout-dnd-utils/dom/bounds';
export const buildCalculateNodePositionsForConfig = nodePositionConfig => {
  let perfStats;
  let lastCalcAllNodePositionsStart;
  return buildCalculateNodePositions(nodePositionConfig, {
    beforeCalculateAnyNodePositions: () => {
      if (!perfStats) {
        perfStats = PerformanceStatsGatherer.getSingletonInstance();
      }
      lastCalcAllNodePositionsStart = perfStats.now();

      // Before the node position pass through all configurations, lookup any "delegated" positions
      setDelegatedElementsForConfigToUse(getDelegatedBoundsElementsByNameOrPath());

      // Before the node position pass through all configurations, get and save the viewport bounds
      setViewportBoundsForConfigToUse(getCurrentViewportBounds());
    },
    afterCalculatingAllNodePositions: () => {
      perfStats.incrementCounterAndMeasure('extractNodePositions', perfStats.now() - lastCalcAllNodePositionsStart);
    }
  });
};